export { default as ADDRESS_TARIFFS_INFO_QUERY_V2 } from "./address_tariffs_info_query_v2";
export { default as DECLINATION_QUERY } from "./declination_query";
export { default as HOUSE_FULL_QUERY } from "./house_full_query";
export { default as REDIRECT_QUERY_V2 } from "./redirect_query_v2";
export { default as SEARCH_NEIGHBOURS_QUERY } from "./search_neighbours_query";
export { default as SEO_QUERY } from "./seo_query";
export { default as SITE_REGION_PHONE_QUERY } from "./site_region_phone_query";
export { default as TARIFFS_BEST_HOUSE_QUERY } from "./tariffs_best_house_query";
export { default as TARIFFS_HOUSE_FILTER_QUERY } from "./tariffs_house_filter_query";
export { default as TARIFFS_HOUSE_QUERY_V4 } from "./tariffs_house_query_v4";
